import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerLoadMoreCard from '../../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../../MediaPickersConstants';

const BackgroundCatalogVideosLoadMoreCard = (props) => {
    const { 
        galleryCardWidth, galleryCardHeight, backgroundCatalogVideosPageNumber, backgroundCatalogVideosLoading, setProperty, loadBackgroundCatalogVideos
    } = props;
    
    const onLoadMoreButtonClick = () => {
        setProperty('backgroundCatalogVideosLoading', true);
        
        loadBackgroundCatalogVideos(backgroundCatalogVideosPageNumber + 1, MediaPickersConstants.BACKGROUND_CATALOG_VIDEOS_PER_PAGE, () => {
            setProperty('backgroundCatalogVideosLoading', false);
        });
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={backgroundCatalogVideosLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundCatalogVideosLoading,
        backgroundCatalogVideosPageNumber
    } = state.mediaPicker;

    return { 
        backgroundCatalogVideosLoading,
        backgroundCatalogVideosPageNumber
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadBackgroundCatalogVideos = (pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.loadBackgroundCatalogVideos(pageNumber, itemsPerPage, callback));

    return { 
        setProperty,
        loadBackgroundCatalogVideos
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundCatalogVideosLoadMoreCard);